<div *ngIf="toast" class="toast-backdrop" (click)="onBackdropClick()" ></div>

<div *ngIf="toast"
     [@hideAnimation]="animationState"
     [ngClass]="getClass(toast?.type) + (toast.className ? ' ' + toast.className : '')"
     class="toast">

    <div class="message" [innerHTML]="toast?.message"></div>
    <div class="btn btn-icon-only" (click)="onCloseBtnClick()">
        <i class="fa fa-times-circle"></i>
    </div>

</div>
